/**
 * Alle Workspace-Text-Vorlagen (CopyForge) für das Rezept-Select in
 * `StepChannels` — ungefiltert nach `tool_code`, analog dem Text-Hub
 * (`fetchAllWorkspaceTextTemplates`, siehe `textGenerationApi.ts`).
 */

import { useQuery } from '@tanstack/react-query'

import { fetchAllWorkspaceTextTemplates } from '@/components/v2/tools/text/textGenerationApi'

export function useTextTemplates() {
  return useQuery({
    queryKey: ['text-workspace-templates', 'all'],
    queryFn: fetchAllWorkspaceTextTemplates,
  })
}
